<template>
    <div>
    
        <div class="mg-y-10 tx-18" style="color: #21242e">{{ title }}</div>
        <ul class="list-group list-group-flush tx-14 course-list-group">
            <!-- <router-link :to="{ name: 'lmsCourseView', params: { id: c.id, bid: 0, iid: 0, bot: 0 } }" class="list-group-item d-flex pd-sm-x-20" role="button" v-for="(c,ci) in list" :key="ci"> -->
            <router-link :to="{ name: c.firstLessonId>0?'lmsLessonView':'lmsCourseView', 
            params: c.firstLessonId>0?{ id: c.firstLessonId, cid: c.id, bid: 0, iid: 0, bot: 0 } 
            :{ id: c.id, bid: 0, iid: 0, bot: 0 }
            }" class="list-group-item d-flex pd-sm-x-20" role="button" v-for="(c,ci) in list" :key="ci">                
                <div>
                    <div class="avatar wd-40 ht-40">
                        <img :src="`${c.cover}?w=40&h=40&mode=crop`" class="avatar-initial rounded-circle" />
                    </div>
                </div>
                <div class="pd-sm-l-10">
                    <p class="tx-medium mg-b-0">{{c.name}}</p>
                    <small class="tx-12 tx-color-03 mg-b-0">{{c.startDate | moment('YYYY.MM.DD')}} - {{c.endDate | moment('YYYY.MM.DD')}}</small>
                </div>
            </router-link>
            
        </ul>
</div>
</template>
<script>
export default {
    props:{
        title: {
        type: String,
        default: () => ''
      }, list: {
        type: Array,
        default: () => []
      }
    },
}
</script>